/**
 * Formats API endpoints to prepend the backend base URL when defined.
 * If REACT_APP_BASE_URL is not set, it returns the relative path which
 * will default to using the development proxy configured in package.json.
 * 
 * @param {string} path - The API endpoint path (e.g. '/api/projects')
 * @returns {string} The fully qualified backend URL or relative path
 */
export const getApiUrl = (path) => {
  let baseUrl = process.env.REACT_APP_BASE_URL || '';
  // Strip outer quotes if present
  baseUrl = baseUrl.trim().replace(/^["']|["']$/g, '');
  const cleanBase = baseUrl.trim().replace(/\/+$/, '');
  const cleanPath = path.trim().replace(/^\/+/, '');
  return cleanBase ? `${cleanBase}/${cleanPath}` : `/${cleanPath}`;
};
